import { useContext } from 'react';
import { ThemeContext } from '@/app/providers/ThemeProvider';
import type { ThemeContextValue } from '@/app/providers/ThemeProvider';

export const useTheme = (): ThemeContextValue => {
  const context = useContext(ThemeContext);
  if (!context) throw new Error('useTheme must be used within ThemeProvider');
  return context;
};
